import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { ERROR_404_URL } from "@/core/urls";
import useDocTitle from "@/hooks/use-doc-title";

import OrganisationListOrders from "./OrganisationListOrders";
import { OrganisationStock } from "./OrganisationStock";

export default function Orders() {
  useDocTitle("Orders", false, "Regenerus");
  const match = useRouteMatch();

  return (
    <Switch>
      <Redirect from={`${match.path}`} to={`${match.url}/direct`} exact />
      <Route path={`${match.url}/direct`} exact>
        <OrganisationListOrders />
      </Route>
      <Route path={`${match.url}/stock`} exact>
        <OrganisationStock />
      </Route>
      <Redirect to={ERROR_404_URL} />
    </Switch>
  );
}
